<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog :close-on-click-modal="false" title="项目列表" :show-close="true" :visible="true"
    :before-close="handleBeforeClose" width="1300px">
    <div class="dialog__container">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="待执行" name="pending">
          <DetailTableData :editData="detail" :tabStatus="10"></DetailTableData>
        </el-tab-pane>
        <el-tab-pane label="进行中" name="processing">
           <DetailTableData :editData="detail" :tabStatus="20"></DetailTableData>
        </el-tab-pane>
        <el-tab-pane label="已完成" name="completed">
          <DetailTableData :editData="detail" :tabStatus="30"></DetailTableData>
        </el-tab-pane>
      </el-tabs>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button class="plr28" type="primary" size="mini" @click="handleConfirm">确定</el-button>
    </span>

  </el-dialog>

</template>

<script>
  import {
    deleteContractCollection
  } from "@/api/ContractReceivables";
  import AddDialog from "./addDialog.vue";
  import {
    getProjectPageList
  } from "@/api/salesManagement/dxjh";
  import {
    mapState
  } from "vuex";
  import AddCause from "./AddCause.vue";
  import DetailProject from "./DetailProoject";
  import DetailTableData from "./DetailTableData";
  export default {

    data() {
      return {
        activeTab: 'pending',
        showAdd: false,
        tableData: [],
        detail: {},
        pageIndex: 1,
        pageSize: 50,
        total: 0,
        tableLoading: true,
        causeDetail: {},
        editCauseVisible: false,
        projectId: null,
        detailProjectVisible: false
      };
    },
    components: {
      AddDialog,
      AddCause,
       DetailProject,DetailTableData
    },
    props: {
      editData: {
        required: true,
      },
    },
    created() {
      this.detail = {
        ...this.editData
      };
      // this.getProjectPageListFun();
    },
    computed: {
      ...mapState("common/dictionary", ["zffsDicts"]),
    },
    methods: {
      // 新增：处理tab切换事件
      handleTabClick(tab) {
        // this.getProjectPageListFun();

      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.getProjectPageListFun();
      },
      handleCurrentChange(val) {
        this.pageIndex = val;
        this.getProjectPageListFun();
      },
      async getProjectPageListFun() {
        this.tableLoading = true;
        const params = {
          planId: this.editData.id,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          tabStatue: this.activeTab === 'pending' ? 10 : this.activeTab === 'processing' ? 20 : 30 // 新增：根据tab状态筛选
        };
        const res = await getProjectPageList(params);
        if (res.code === 200) {
          this.tableData = [...res.data.list];
          this.total = res.data.total;
        }
        this.tableLoading = false;
      },
      handleBeforeClose(done) {
        this.$emit("cancel");
        done();
      },
      handleCancel() {
        this.$emit("cancel");
      },
      async handleConfirm() {
        this.$emit("confirm");
      },
      handleDetailProjectConfirm() {
        this.editProjectVisible = false;
        this.getListData();
      },
      addPlan() {
        this.showAdd = true;
      },
      confirm() {
        this.showAdd = false;
        this.realList();
      },
      async handleDelete(row) {
        this.$confirm("确定删除?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(async () => {
            const res = await deleteContractCollection({
              idList: [row.id]
            });
            if (res.code === 200) {
              this.$message.success("删除成功");
              this.realList();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      handleEdit(row) {
        this.detail = {
          ...row
        };
        this.detail = {
          planId: this.editData.id,
          projectId: row.id
        };
        this.showAdd = true;
      },
      handleDtxx(row) {
        this.projectId = row.id
        this.detailProjectVisible = true;
      },
      receiptMethodFormatter(row) {
        let str = "";
        this.zffsDicts.some((item) => {
          if (item.dictionaryCode == row.receiptMethod) {
            str = item.dictionaryValue;
            return true;
          }
        });
        return str;
      },
      handleTransferOrder(row) {
        this.detail = {
          ...row
        };
        this.causeDetail = {
          planId: this.editData.id,
          projectId: row.id
        };
        this.editCauseVisible = true;
      },
      handleEditCauseConfirm() {
        this.editCauseVisible = false;
        this.getProjectPageListFun();
      },
      needInvoiceFormatter(row) {
        if (row.needInvoice == 0) {
          return "否";
        }
        if (row.needInvoice == 1) {
          return "是";
        }
        return "";
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/salesManagement/dxjh/components/checkDialog.vue